const eventTypes = {
    event_project: "Wydarzenie / Projekt",
    organization: "Organizacja"
}

export default eventTypes
